// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"444e6c6d","996":"444e6c6d"}[chunkId] + ".chunk.css";
};